var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.showDialog,
        width: "780px",
        "close-on-click-modal": false,
      },
      on: {
        "update:visible": function ($event) {
          _vm.showDialog = $event
        },
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "rulesetting--form__title",
          attrs: { slot: "title" },
          slot: "title",
        },
        [
          _vm._v(
            " " + _vm._s(_vm.$t("storage::stock-analysis::rule_setting")) + " "
          ),
          _c(
            "el-tooltip",
            {
              attrs: {
                effect: "dark",
                content: _vm.$t("storage::stock-analysis::rule_set_tips"),
                placement: "top-start",
              },
            },
            [
              _c("i", {
                staticClass: "el-icon-question",
                staticStyle: { color: "#999999" },
              }),
            ]
          ),
        ],
        1
      ),
      _c(
        "el-form",
        { staticClass: "rulesetting--form" },
        [
          _c(
            "el-form-item",
            [
              _c("template", { slot: "label" }, [
                _c("span", { staticClass: "rulesetting--form__label" }, [
                  _vm._v(_vm._s(_vm.$t("storage::stock-analysis::full_days"))),
                ]),
              ]),
              _c(
                "div",
                [
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("storage::stock-analysis::可用库存 / 近")) +
                      " "
                  ),
                  _c("el-input-number", {
                    staticClass: "rulesetting--form__input",
                    attrs: { min: 0, max: 30, "controls-position": "right" },
                    on: {
                      change: function (val) {
                        return _vm.checkDay(val, "satisfyDays")
                      },
                    },
                    model: {
                      value: _vm.ruleSet.satisfyDays,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleSet, "satisfyDays", $$v)
                      },
                      expression: "ruleSet.satisfyDays",
                    },
                  }),
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("storage::stock-analysis::天日均销量")) +
                      " "
                  ),
                ],
                1
              ),
            ],
            2
          ),
          _c(
            "el-form-item",
            [
              _c("template", { slot: "label" }, [
                _c("span", { staticClass: "rulesetting--form__label" }, [
                  _vm._v(
                    _vm._s(_vm.$t("storage::stock-analysis::purchase_suggest"))
                  ),
                ]),
              ]),
              _c(
                "div",
                [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$t("storage::stock-analysis::当满足天数少于")
                      ) +
                      " "
                  ),
                  _c("el-input-number", {
                    staticClass: "rulesetting--form__input",
                    attrs: { min: 0, max: 30, "controls-position": "right" },
                    on: {
                      change: function (val) {
                        return _vm.checkDay(val, "purchaseDays")
                      },
                    },
                    model: {
                      value: _vm.ruleSet.purchaseDays,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleSet, "purchaseDays", $$v)
                      },
                      expression: "ruleSet.purchaseDays",
                    },
                  }),
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$t("storage::stock-analysis::天时该SPU为建议采购")
                      ) +
                      " "
                  ),
                ],
                1
              ),
            ],
            2
          ),
          _c(
            "el-form-item",
            [
              _c("template", { slot: "label" }, [
                _c("span", { staticClass: "rulesetting--form__label" }, [
                  _vm._v(_vm._s(_vm.$t("storage::stock-analysis::sales_rise"))),
                ]),
              ]),
              _c(
                "div",
                [
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("storage::stock-analysis::本周期")) +
                      " "
                  ),
                  _c("el-input-number", {
                    staticClass: "rulesetting--form__input",
                    attrs: { min: 0, max: 30, "controls-position": "right" },
                    on: {
                      change: function (val) {
                        return _vm.checkDay(val, "cycleUpDays")
                      },
                    },
                    model: {
                      value: _vm.ruleSet.cycleUpDays,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleSet, "cycleUpDays", $$v)
                      },
                      expression: "ruleSet.cycleUpDays",
                    },
                  }),
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$t(
                          "storage::stock-analysis::天环比上一周期销量上涨"
                        )
                      ) +
                      " "
                  ),
                  _c("el-input-number", {
                    staticClass: "rulesetting--form__input",
                    attrs: { min: 0, "controls-position": "right" },
                    model: {
                      value: _vm.ruleSet.cycleUpPercentage,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleSet, "cycleUpPercentage", $$v)
                      },
                      expression: "ruleSet.cycleUpPercentage",
                    },
                  }),
                  _vm._v(
                    " %, " +
                      _vm._s(
                        _vm.$t("storage::stock-analysis::该SPU为销量上涨")
                      ) +
                      " "
                  ),
                ],
                1
              ),
            ],
            2
          ),
          _c(
            "el-form-item",
            [
              _c("template", { slot: "label" }, [
                _c("span", { staticClass: "rulesetting--form__label" }, [
                  _vm._v(_vm._s(_vm.$t("storage::stock-analysis::sales_down"))),
                ]),
              ]),
              _c(
                "div",
                [
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("storage::stock-analysis::本周期")) +
                      " "
                  ),
                  _c("el-input-number", {
                    staticClass: "rulesetting--form__input",
                    attrs: { min: 0, max: 30, "controls-position": "right" },
                    on: {
                      change: function (val) {
                        return _vm.checkDay(val, "cycleDownDays")
                      },
                    },
                    model: {
                      value: _vm.ruleSet.cycleDownDays,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleSet, "cycleDownDays", $$v)
                      },
                      expression: "ruleSet.cycleDownDays",
                    },
                  }),
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$t(
                          "storage::stock-analysis::天环比上一周期销量下降"
                        )
                      ) +
                      " "
                  ),
                  _c("el-input-number", {
                    staticClass: "rulesetting--form__input",
                    attrs: { min: 0, "controls-position": "right" },
                    model: {
                      value: _vm.ruleSet.cycleDownPercentage,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleSet, "cycleDownPercentage", $$v)
                      },
                      expression: "ruleSet.cycleDownPercentage",
                    },
                  }),
                  _vm._v(
                    " %，" +
                      _vm._s(
                        _vm.$t("storage::stock-analysis::该SPU为销量下降")
                      ) +
                      " "
                  ),
                ],
                1
              ),
            ],
            2
          ),
          _c(
            "el-form-item",
            [
              _c("template", { slot: "label" }, [
                _c(
                  "span",
                  {
                    staticClass: "rulesetting--form__label",
                    staticStyle: { "margin-right": "12px" },
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(_vm.$t("storage::stock-analysis::un_move")) +
                        " "
                    ),
                  ]
                ),
              ]),
              _c(
                "div",
                [
                  _vm._v(
                    " " + _vm._s(_vm.$t("storage::stock-analysis::近")) + " "
                  ),
                  _c("el-input-number", {
                    staticClass: "rulesetting--form__input",
                    attrs: { min: 0, max: 30, "controls-position": "right" },
                    on: {
                      change: function (val) {
                        return _vm.checkDay(val, "fixPinDays")
                      },
                    },
                    model: {
                      value: _vm.ruleSet.fixPinDays,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleSet, "fixPinDays", $$v)
                      },
                      expression: "ruleSet.fixPinDays",
                    },
                  }),
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$t(
                          "storage::stock-analysis::天销量为零该SPU为不动销商品"
                        )
                      ) +
                      " "
                  ),
                ],
                1
              ),
            ],
            2
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          staticStyle: { "text-align": "center" },
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              staticStyle: { width: "96px" },
              attrs: { size: "small" },
              on: {
                click: function ($event) {
                  _vm.showDialog = false
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$t("system::common::btn::cancel")) + " ")]
          ),
          _c(
            "el-button",
            {
              staticStyle: { width: "96px" },
              attrs: { type: "primary", size: "small" },
              on: { click: _vm.saveRule },
            },
            [_vm._v(" " + _vm._s(_vm.$t("system::common::btn::save")) + " ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }